import { createFileRoute } from '@tanstack/react-router';

import { EstadoRegistryPage } from '@/features/clients/components/client-estado/estado-registry-page';

// /clients/estado — vista de clientes suspendidos y dados de baja.
// Muestra tabla con motivo, fecha, ejecutivo y acciones de cambio de estado.
export const Route = createFileRoute('/_app/clients/estado')({
  component: EstadoRegistryPage,
});
